import React, { ChangeEvent } from 'react';
import { InputCheckBox, CheckMarkWrapper, IconWrapper } from './BonusCheckBox.style';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface BonusCheckboxPropsType {
    isChecked: boolean;
    handleOnChange: ((e: ChangeEvent<HTMLInputElement>) => void) | (() => void);
}

export const BonusCheckbox = observer(
    'BonusCheckbox',
    ({ isChecked, handleOnChange }: BonusCheckboxPropsType): React.ReactElement => {
        const common = useCommon();
        const configState = ConfigComponents.get(common).config;
        return (
            <>
                <InputCheckBox
                    type='checkbox'
                    onChange={handleOnChange}
                    checked={isChecked}
                />

                <IconWrapper
                    isChecked={isChecked}
                    variant={configState.componentVariants.betslipVariant}
                >
                    <CheckMarkWrapper isChecked={isChecked} />
                </IconWrapper>
            </>
        );
    }
);
